import React from 'react';

interface TaskAlertMessagesProps {
  messages?: string[];
}

const TaskAlertMessages: React.FC<TaskAlertMessagesProps> = ({ messages = [] }) => {
  if (messages.length === 0) {
    return null;
  }

  return (
    <div className="task-alert-messages alert alert-info alert-dismissible fade show m-2 p-2 pe-4">
      {messages.map((message) => (
        <div key={message}>
          {message}
        </div>
      ))}
      <button type="button" className="btn-close px-2 py-3" data-bs-dismiss="alert" aria-label="Close" />
    </div>
  );
};

export default TaskAlertMessages;
